var React = require('react');

function FeatureTerrainParkMedium (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"164","rx":"82","fill":"#F58021","key":0}),React.createElement("path",{"d":"M110.812 116V47.2812H131.578L144.047 94.1562L156.375 47.2812H177.188V116H164.297V61.9062L150.656 116H137.297L123.703 61.9062V116H110.812Z","fill":"white","key":1})]);
}

FeatureTerrainParkMedium.defaultProps = {"viewBox":"0 0 288 164","fill":"none"};

module.exports = FeatureTerrainParkMedium;

FeatureTerrainParkMedium.default = FeatureTerrainParkMedium;
